import { useState } from "react";
import IconCard from "./IconCard";
import { IconPickerDialog } from "./IconPickerDialog";

type IconSelectionButtonProps = {
  icon?: string;
  onChange: (icon?: string) => void;
};

const IconSelectionButton: React.FC<IconSelectionButtonProps> = (props) => {
  const [iconPickerOpen, setIconPickerOpen] = useState(false);

  const onClose = (icon?: string) => {
    setIconPickerOpen(false);
    props.onChange(icon);
  };
  return (
    <div className="iconGrid p-m-2" style={{ justifyContent: "left" }}>
      <IconCard
        iconName={props.icon || "pi pi-code"}
        onClick={() => setIconPickerOpen(true)}
      />
      <IconPickerDialog
        visible={iconPickerOpen}
        onClose={onClose}
        icon={props.icon}
      />
    </div>
  );
};

export default IconSelectionButton;
